/**
 * Format decimal string by removing trailing zeros
 * Example: "30000.00" -> "30000"
 */
export function formatDecimal(value: string): string {
  if (!value.includes('.')) {
    return value;
  }
  // Remove trailing zeros after decimal point
  const trimmed = value.replace(/0+$/, '');
  // Remove decimal point if no digits after it
  return trimmed.replace(/\.$/, '');
}

/**
 * Convert USD amount to microUSD (HL API format)
 */
export function usdToMicroUsd(usd: number): number {
  return Math.round(usd * 1e6);
}

/**
 * Convert microUSD to USD
 */
export function microUsdToUsd(microUsd: number): number {
  return microUsd / 1e6;
}

/**
 * Validate numeric string
 */
export function isValidNumericString(value: string): boolean {
  return /^-?\d+\.?\d*$/.test(value);
}
